<template>
  <div>
    <div :class="$style.base">
      <BaseText v-for="(timeslot, index) in timeSlots" :key="index">
        <Timeframe
          v-if="showTimelot(index)"
          id="Timeframe_1"
          :timeslot="timeslot"
          :selected="selectedTimeslot === timeslot"
          @click="clickDLPush('selektieren-' + index, 'checkboxclick'),
                  selectTimeframe(timeslot)"
        />
      </BaseText>
    </div>
    <Spacer :mt="4" />
    <TextContainer v-if="showToggleButton()" align="center">
      <BaseIcon v-if="!isExpanded" icon="iconChevron" :class="[$style.baseChevron, $style.chevronDown]" />
      <BaseIcon v-if="isExpanded" icon="iconChevron" :class="[$style.baseChevron, $style.chevronUp]" />
      <BaseLink
        @click="clickDLPush(isExpanded ? 'liste-einklappen' : 'liste-ausklappen', 'click'),
                toggleExpanded()"
      >
        <span v-if="!isExpanded" :class="$style.linkTextColor">
          Weitere Termine
        </span><span v-if="isExpanded" :class="$style.linkTextColor">
          Weniger Termine
        </span>
      </BaseLink>
    </TextContainer>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import { computed, onMounted, ref } from 'vue'
import Timeframe from './TimeframeListItem.vue'
import { useDataLayerMixin } from '~/base/composables/useDataLayer'
import type { AvailableTimeslot } from '~/terminierungsportal/types/appointmentTypes'
import { useAppointmentStore } from '~/terminierungsportal/stores/appointment'
import Spacer from '~/base/components/spacer/Spacer.vue'
import BaseIcon from '~/base/components/icon/Icon.vue'
import BaseLink from '~/base/components/link/Link.vue'
import BaseText from '~/base/components/text/Text.vue'
import TextContainer from '~/base/components/textContainer/TextContainer.vue'

const props = defineProps({
  selectedTimeslot: {
    type: Object as PropType<AvailableTimeslot>,
    required: true
  }
})
const emits = defineEmits(['timeslotSelected', 'toggleExpandState'])
const appointmentStore = useAppointmentStore()
const initialDisplayEntries = ref(4)
const expanded = ref(false)
const { clickDLPush } = useDataLayerMixin()

onMounted(() => {
  if (!showToggleButton()) {
    toggleExpanded()
  }
})

const isExpanded = computed((): boolean => {
  return expanded.value
})

const toggleExpanded = (): void => {
  expanded.value = !expanded.value
  emits('toggleExpandState', expanded.value)
}

const showToggleButton = (): boolean => {
  return (
    appointmentStore.availableTimeSlots.length > initialDisplayEntries.value
  )
}

const showTimelot = (index: number): boolean => {
  return index < initialDisplayEntries.value || expanded.value
}

const timeSlots = computed((): AvailableTimeslot[] => {
  return appointmentStore.availableTimeSlots
})

const selectTimeframe = (timeslot: AvailableTimeslot): void => {
  emits(
    'timeslotSelected',
    props.selectedTimeslot !== timeslot ? timeslot : null
  )
}
</script>

<style module>
.base {
  margin-top: var(--space-sm);
  & > * {
    margin-top: 9px;
  }
}

.baseChevron {
  display: inline;

  &::before {
    margin-right: 8px;
    width: 12px;
    height: 12px;
    display: inline-block;
    font-size: 12px;
    text-decoration: none;
    color: var(--color-pacificblue);
  }
}

.chevronUp {
  &::before {
    transform: rotate(90deg);
  }
}

.chevronDown {
  &::before {
    transform: rotate(-90deg);
  }
}

.linkTextColor {
  color: var(--color-pacificblue);
}

</style>
